/**
 * Returns a random integer between min (inclusive) and max (exclusive).
 *
 * @param min - The minimum value (inclusive)
 * @param max - The maximum value (exclusive)
 * @returns A random integer in the range [min, max)
 *
 * @example
 * randomInt(0, 10) // Returns 0-9
 * randomInt(5, 15) // Returns 5-14
 */
export function randomInt(min: number, max: number): number {
  return Math.floor(Math.random() * (max - min)) + min;
}
